<template>
    <div>
		<div :style="(deep == 0 ? '' : 'border: 1px black solid; padding:10px;') + ((instruction == '' || instruction == 'if') ? 'margin-top: 20px' : '')">

			<div v-if="deep == 0 && rules_blocks.length > 0">

				<b-button variant="link" @click="setReduce(true)"><i class="fas fa-eye-slash"></i></b-button>
				<b-button variant="link" @click="setReduce(false)"><i class="fas fa-eye"></i></b-button>

			</div>

			<div v-if="reduce && deep != 0">
				<h4>
					<b-button variant="link" @click="reduce = false"><i class="fas fa-eye-slash"></i></b-button>
					Règle <b-input style="width:200px; display: inline" v-model='name'></b-input>&nbsp;
					<b-button size="sm" v-if="instruction == 'if'" variant="success">Si</b-button>
					<b-button size="sm" v-if="instruction == 'else if'" variant="success">Sinon si</b-button>
					<b-button size="sm" v-if="instruction == 'else'" variant="success">Sinon</b-button>
					<b-button variant="link" class="handle"><i class="fas fa-arrows-alt"></i></b-button>
				</h4>
			</div>
			<div v-show="deep == 0 || !reduce">
				<div v-if="deep != 0">	
					<h4><b-button variant="link" @click="reduce = true"><i class="fas fa-eye"></i></b-button>Règle <b-input style="width:200px; display: inline" v-model='name'></b-input></h4>

					<b-button @click="instruction = ''" :variant="instruction == '' ? 'success' : 'outline-success'">Pas de conditions</b-button>&nbsp;
					<b-button @click="instruction = 'if'" :variant="instruction == 'if' ? 'success' : 'outline-success'">Si</b-button>&nbsp;
					<b-button @click="instruction = 'else if'" :variant="instruction == 'else if' ? 'success' : 'outline-success'">Sinon si</b-button>&nbsp;
					<b-button @click="instruction = 'else'" :variant="instruction == 'else' ? 'success' : 'outline-success'">Sinon</b-button>&nbsp;

					<br /><br />

					<div v-if="instruction == 'if' || instruction == 'else if'">
						<p>Conditions</p>

						<rules_condition :options="options" ref="conditions" :columns="columns"></rules_condition>
					</div>

					<p>Actions</p>
				</div>

				<draggable handle=".handle" :list="rules_blocks" :group="{ name: 'blocks' }" :clone="onClone" @change="onChange" @start="onStart">
					<div style="padding:0px 10px 0px 10px" v-for="(block, idx) in rules_blocks" :key="block.uid">
						<rules_block :options="options" :columns="columns" v-if="block.type == 'rule' || !block.type" :initials_data="block" :ref="block.uid" @remove="remove_block" @duplicate="duplicate_block"></rules_block>
						<div v-else style="margin-top: 20px">
							<div style="border: 1px black solid; padding:10px;">
								<h4>Action
									<b-select style="width:200px; display: inline" @change="change_type(idx)" v-model="block.type_action" :options="[
										{value: 'columns', text: 'Colonnes'},
										{value: 'line_code', text: 'Ligne de code'},
										{value: 'return', text: 'Stop des règles'},
										{value: 'code', text: 'Code'}
									]"></b-select>
								</h4>
								<div v-if="block.type_action == 'return'">
								</div>
								<div v-if="block.type_action == 'line_code'">
									<b-input v-model="block.params.code"></b-input>
									<b-button variant="link" class="handle"><i class="fas fa-arrows-alt"></i></b-button>
									<b-button variant="link" @click="del(idx)"><i class="fas fa-trash"></i></b-button>
								</div>
								<div v-if="block.type_action == 'code'">
									<div style="
											width: 100%;
											height: 70px;
											display: inline-block;
											position: relative;
										">
										<pre
											style="width: 100%; height: 100%"
											:id="'ace_editor-' + uid + idx"></pre>
									</div>
									<b-button variant="link" class="handle"><i class="fas fa-arrows-alt"></i></b-button>
									<b-button variant="link" @click="del(idx)"><i class="fas fa-trash"></i></b-button>
								</div>
								<div v-if="block.type_action == 'columns'">
									<div v-for="(column, c_idx) in block.params.columns" :key="c_idx">
										Colonne <b-input :list="uid + '-columns-' + idx + '-' + c_idx" style="width:20%; display: inline" v-model="column.column"></b-input>
										&nbsp;
										<datalist :id="uid + '-columns-' + idx + '-' + c_idx">
											<option :key="idx" v-for="(col, idx) in columns">{{col}}</option>
										</datalist>
										<b-select style="width:200px; display: inline" v-model="column.operator" :options="[
											{value: 'set', text: '='},
											{value: 'plus', text: '+'},
											{value: 'minus', text: '-'},
											{value: 'add_array', text: 'ajouter à un tableau'},
											{value: 'add_object', text: 'ajouter à un objet'}
										]"></b-select>										 
										<span v-if="column.operator == 'add_object'">
											clé 
											<b-input style="width:20%; display: inline" v-model="column.key"></b-input>
										</span>
										 valeur 
										<b-input :list="uid + '-value-' + idx" style="width:20%; display: inline" v-model="column.value"></b-input>
										<datalist v-if="options.columns_list[column.column]" :id="uid + '-value-' + idx">
											<option :key="idx" v-for="(column, idx) in options.columns_list[column.column]">{{column}}</option>
										</datalist>
										<b-button variant="link" @click="block.params.columns.splice(c_idx, 1)"><i class="fas fa-trash"></i></b-button>
									</div>
									<b-button variant="link" @click="block.params.columns.push({'column' : '', 'value': '', 'operator': 'set'})"><i class="fas fa-plus"></i></b-button>
									<b-button variant="link" class="handle"><i class="fas fa-arrows-alt"></i></b-button>
									<b-button variant="link" @click="del(idx)"><i class="fas fa-trash"></i></b-button>
								</div>
							</div>
						</div>
					</div>
				</draggable>

				<b-button variant="link" @click="addBlock('rule')"><i class="fas fa-plus"></i> règle</b-button>
				<b-button variant="link" @click="addBlock('action')"><i class="fas fa-plus"></i> action</b-button>

				<span v-if="deep != 0">
					<b-button variant="link" class="handle"><i class="fas fa-arrows-alt"></i></b-button>
					<b-button variant="link" @click="del()"><i class="fas fa-trash"></i></b-button>
					<b-button variant="link" @click="duplicate()"><i class="fas fa-clone"></i></b-button>
				</span>

				<b-button variant="link" @click="setReduce(true)"><i class="fas fa-eye-slash"></i></b-button>
				<b-button variant="link" @click="setReduce(false)"><i class="fas fa-eye"></i></b-button>

				<b-button variant="link" @click="showCode()"><i class="fas fa-code"></i></b-button>

        <div v-show="currentCode.length > 0">
          <h4>Code</h4>
          <pre>{{currentCode}}</pre>
        </div>

			</div>
		</div>
    </div>
</template>

<script>
	import "../../public/js/ace-builds/src-min-noconflict/ace.js";
	import "../../public/js/ace-builds/src-min-noconflict/ext-language_tools.js";

	import store from "../store";
	import draggable from "vuedraggable";
	import rules_condition from "./rules_condition.vue"

    var clone = require("clone");
    const _ = require("underscore");

	export default {
		name: "rules_block",
		components: {
			draggable,
			rules_condition
		},
		data() {
			return {
				uid: this.$uuid.v4(),
				rules_blocks: [],
				deep: 0,
				name: "",
				instruction: "",
				conditions: [],
				reduce: false,

        currentCode: ""
      }
		},
		props: {
			library: {
				default: false
			},
			initials_data: {
				type: Object,
				default() {
					return {}
				}
			},
			columns: {
				type: Array,
				default() {
					return []
				}
			},
			options: {
				type: Object,
				default() {
					return {}
				}
			}
		},
		computed: {
		},
        methods: 
        {

          showCode() {
            if (this.currentCode.length > 0) {
              this.currentCode = "";
            } else {

              this.generate_code().then((code) => {
                this.currentCode = code;
              });
            }
          },
			reset()
			{
				this.uid = this.$uuid.v4();
				this.rules_blocks = [];
				this.deep = 0;
				this.name = "";
				this.instruction = "";
				this.conditions = [];
				this.reduce = false;
			},
			setReduce(reduce, level = 0)
			{
				if (level)
					this.reduce = reduce;

				for (var i = 0; i < this.rules_blocks.length; i++)
				{
					if (this.rules_blocks[i].type == 'rule' || !this.rules_blocks[i].type)
					{
						this.$refs[this.rules_blocks[i].uid][0].setReduce(reduce, 1);
					}
				}
			},
			onClone(data)
			{
				var uid = data.uid;
				// console.log("clone " + uid)
				this.save();
				for (var i = 0; i < this.rules_blocks.length; i++)
				{
					if (this.rules_blocks[i].uid == uid)
					{
						return clone(this.rules_blocks[i])
					}
				}
			},
			onChange(evt)
			{
				if (evt.added)
				{
					var idx = evt.added.newIndex;
					var element = evt.added.element;
					if (element.type_action == "code")
					{
						var ace_editor = ace.edit("ace_editor-" + this.uid + idx);
						ace_editor.session.setMode("ace/mode/javascript");
						var theme = "chrome";
						if (
							store &&
							store.state &&
							store.state.style &&
							store.state.style.theme &&
							store.state.style.theme.code
						)
							theme = store.state.style.theme.code;
						ace_editor.setTheme("ace/theme/" + theme);
						// enable autocompletion and snippets
						ace_editor.setOptions({
							enableBasicAutocompletion: true,
							enableSnippets: true,
							enableLiveAutocompletion: true,
						});
						ace_editor.setValue(element.params.code)
					}
				}
			},
			onStart(evt)
			{
			},
			async load(data)
			{
				//console.log("data")
				//console.log(data)
				var self = this;
				
				if (!data) return;
				if (data.uid)
					this.uid = data.uid;
				if (data.name)
					this.name = data.name;
				if (data.instruction)
					this.instruction = data.instruction;
				if (data.conditions)
					this.conditions = data.conditions;
				if (data.deep)
					this.deep = data.deep;
				if (data.rules_blocks)
					this.rules_blocks = data.rules_blocks;

                self.$nextTick(async function () {
					if (this.$refs.conditions)
						this.$refs.conditions.load(data.conditions);

					for (var idx = 0; idx < self.rules_blocks.length; idx++)
					{
						if (self.rules_blocks[idx].type_action == "code")
						{
							var ace_editor = ace.edit("ace_editor-" + self.uid + idx);
							ace_editor.session.setMode("ace/mode/javascript");
							var theme = "chrome";
							if (
								store &&
								store.state &&
								store.state.style &&
								store.state.style.theme &&
								store.state.style.theme.code
							)
								theme = store.state.style.theme.code;
							ace_editor.setTheme("ace/theme/" + theme);
							// enable autocompletion and snippets
							ace_editor.setOptions({
								enableBasicAutocompletion: true,
								enableSnippets: true,
								enableLiveAutocompletion: true,
							});
							ace_editor.setValue(self.rules_blocks[idx].params.code)
						}
					}
                });
			},
			save()
            {
				var rules_blocks = [];
				for (var i = 0; i < this.rules_blocks.length; i++)
				{
					if (this.rules_blocks[i].type == 'rule' || !this.rules_blocks[i].type)
					{
						var block = this.$refs[this.rules_blocks[i].uid][0].save();
						rules_blocks.push(block)
					}
					else
					{
						rules_blocks.push(this.rules_blocks[i]);
						if (this.rules_blocks[i].type_action == "code")
						{
							var ace_editor = ace.edit("ace_editor-" + this.uid + i);
							this.rules_blocks[i].params.code = ace_editor.getValue()
						}
					}
				}

				var conditions = [];
				if (this.instruction == 'if' || this.instruction == 'else if')
				{
					conditions = this.$refs.conditions.save();
				}

				this.rules_blocks = rules_blocks;
				this.conditions = conditions;

				return {
					name: this.name,
					uid: this.uid,
					rules_blocks: rules_blocks,
					deep: this.deep,
					instruction: this.instruction,
					conditions: conditions
				}
			},
			async addBlock(type)
			{
				if (type == "rule")
				{
					this.rules_blocks.push({
						deep: this.deep + 1,
						uid: this.$uuid.v4(),
						type: type,
						instruction: "",
						operator: "set"
					})
				}
				else
				{
					this.rules_blocks.push({
						deep: this.deep + 1,
						uid: this.$uuid.v4(),
						type: type,
						type_action: "columns",
						params: {
							columns: [{
								column: "",
								value: "",
								operator: "set",
							}]
						},
					})
				}
			},
			change_type(idx)
			{
				var self = this;

				switch (this.rules_blocks[idx].type_action)
				{
					case "return":
						this.rules_blocks[idx].params = { };
						break;
					case "line_code":
						this.rules_blocks[idx].params = { code: ""};
						break;
					case "code":
						this.rules_blocks[idx].params = { code: ""};
						break;
					case "columns":
						this.rules_blocks[idx].params = { 
							columns: [{
								column: "",
								value: "",
								operator: "set",
							}]
						};
						break;
				}

				self.$nextTick(async function () {
					if (self.rules_blocks[idx].type_action == "code")
					{
						var ace_editor = ace.edit("ace_editor-" + self.uid + idx);
						ace_editor.session.setMode("ace/mode/javascript");
						var theme = "chrome";
						if (
							store &&
							store.state &&
							store.state.style &&
							store.state.style.theme &&
							store.state.style.theme.code
						)
							theme = store.state.style.theme.code;
						ace_editor.setTheme("ace/theme/" + theme);
						// enable autocompletion and snippets
						ace_editor.setOptions({
							enableBasicAutocompletion: true,
							enableSnippets: true,
							enableLiveAutocompletion: true,
						});
					}
                });
			},
			del(idx = null)
			{
				if (idx != null)
					this.rules_blocks.splice(idx, 1);
				else
					this.$emit("remove", this.uid, true);
			},
			remove_block(uid)
			{
				for (var i = 0; i < this.rules_blocks.length; i++)
				{
					if (this.rules_blocks[i].uid == uid)
					{
						this.rules_blocks.splice(i, 1);
						break;
					}
				}
			},
			duplicate()
			{
				console.log("duplicate");
				this.$emit("duplicate", this.uid);
			},

			duplicate_block(uid)
			{
				for (var i = 0; i < this.rules_blocks.length; i++)
				{
					if (this.rules_blocks[i].uid == uid)
					{
						var block = this.$refs[this.rules_blocks[i].uid][0].save();
						block.uid = this.$uuid.v4();
						this.rules_blocks.push(block);
						break;
					}
				}
			},
			async generate_code()
			{
				var code = "";
				var deep = this.deep;

				deep = this.deep;
				//console.log(this.instruction)
				if (this.instruction)
				{
					deep--;
					for (var j = 0; j < deep; j++)
					{
						code += "	";
					}
					if (this.instruction == 'if')
						code += "if ";
					if (this.instruction == 'else if')
						code += "else if ";
					if (this.instruction == 'else')
						code += "else";
					if (this.instruction == 'if' || this.instruction == 'else if')
					{
						code += await this.$refs.conditions.generate_code();
					}
					code += "{\n"
					
					deep += 2;
				}
				else
				{
					deep--;
				}

				for (var i = 0; i < this.rules_blocks.length; i++)
				{
					if (this.rules_blocks[i].type == 'rule' || !this.rules_blocks[i].type)
					{
						code += await this.$refs[this.rules_blocks[i].uid][0].generate_code();
					}
					else
					{
						if (this.rules_blocks[i].type_action == "line_code")
						{
							for (var j = 1; j < deep; j++)
							{
								code += "	";
							}
							code += this.rules_blocks[i].params.code + "\n";
						}
						else if (this.rules_blocks[i].type_action == "columns")
						{
							for (var j = 0; j < this.rules_blocks[i].params.columns.length; j++)
							{
								for (var k = 1; k < deep; k++)
								{
									code += "	";
								}
								var column = this.rules_blocks[i].params.columns[j].column.replace(/"/g, '\\"');
								var value = this.rules_blocks[i].params.columns[j].value.replace(/"/g, '\\"');
								if (this.rules_blocks[i].params.columns[j].operator == "plus")
								{
									code += 'if (!data["' + column + '"]) { data["' + column + '"] = 0 } data["' + column + '"] = parseFloat(data["' + column + '"]) + parseFloat("' + value + '");\n';
								}
								else if (this.rules_blocks[i].params.columns[j].operator == "minus")
								{
									code += 'if (!data["' + column + '"]) { data["' + column + '"] = 0 } data["' + column + '"] = parseFloat(data["' + column + '"]) - parseFloat("' + value + '");\n';
								}
								else if (this.rules_blocks[i].params.columns[j].operator == "add_array")
								{
									code += 'if (!data["' + column + '"]) { data["' + column + '"] = [] } else if (typeof data["' + column + '"] == "string") { data["' + column + '"] = JSON.parse(data["' + column + '"])} data["' + column + '"].push("' + value + '");\n';
								}
								else if (this.rules_blocks[i].params.columns[j].operator == "add_object")
								{
									var key = this.rules_blocks[i].params.columns[j].key.replace(/"/g, '\\"');
									code += 'if (!data["' + column + '"]) { data["' + column + '"] = {} } data["' + column + '"]["' + key + '"] = "' + value + '";\n';
								}
								else
								{
									code += 'data["' + column + '"] = "' + value + '";\n';
								}
							}
						}
						else if (this.rules_blocks[i].type_action == "code")
						{
							var ace_editor = ace.edit("ace_editor-" + this.uid + i);
							this.rules_blocks[i].params.code = ace_editor.getValue();
							code += this.rules_blocks[i].params.code;
						}
						else if (this.rules_blocks[i].type_action == "return")
						{
							for (var k = 1; k < deep; k++)
							{
								code += "	";
							}
							code += "return data;\n";
						}
					}
				}

				if (this.instruction == 'if' || this.instruction == 'else if' || this.instruction == 'else')
				{
					deep--;
					for (var j = 1; j < deep; j++)
					{
						code += "	";
					}
					code += "}\n";
				}

				return code;
			}
		},
		mounted: async function () {
			var self = this;
			
			//console.log("mounted")
			//console.log(this.initials_data)
	
			if (this.initials_data)
				this.load(clone(this.initials_data));
		},
	};
</script>

<style>
.is-hidden {
    display: none;
}
</style>
